import { Injectable } from '@angular/core';

export class Settings {
    constructor(public name: string,
        public theme: string,
        public rtl: boolean) { }
}

@Injectable()
export class AppSettings {
    public settings = new Settings(
        'Burger King - Nicaragua',  // theme name
        'restaurant',     // green, blue, red, pink, purple, grey, ulaula
        false       // true = rtl, false = ltr
    )

}
